import {combineReducers} from 'redux';
import {REDUX_STORE} from '../constants';
import heartCondition from './../reducers/heartCondition';
import healthFactors from './healthFactors';
import unlockedNavItems from './unlockedNavItems';
import initialOptions from './initialOptions';
import myPriorities from './myPriorities';
import choices from './choices';
import nextSteps from './nextSteps';

const createRootReducer = () => {
  const rootReducerFn = combineReducers({
    unlockedNavItems,
    heartCondition,
    healthFactors,
    initialOptions,
    myPriorities,
    choices,
    nextSteps
  });

  return (state, action) =>
  // eslint-disable-next-line
    rootReducerFn(action.type === REDUX_STORE.RESET_REDUX_STORE ? undefined : state, action);
};

export default createRootReducer;
